const Types = {
  ORDER_MEAL_ALC__SET_FIELD: 'ORDER_MEAL_ALC__SET_FIELD',
  ORDER_MEAL_ALC__RESET_STATE: 'ORDER_MEAL_ALC__RESET_STATE',
};
export default Types;
